import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  standalone: false,
  name: "locationDisplayWithPlaceholder",
})
export class LocationDisplayWithPlaceholderPipe implements PipeTransform {
  transform(location: string | null | undefined): string {
    return location && location.trim().length > 0 ? location : "Unknown";
  }
}
